var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetreatClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6C12 9.31368 9.31368 12 6 12C2.68629 12 0 9.31368 0 6C0 2.68629 2.68629 0 6 0C9.31368 0 12 2.68629 12 6Z",
    fill: "#c2b58c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.8354 3.15625C5.03572 3.15625 5.19813 3.35777 5.19813 3.60635V5.8204L6.30101 7.18893C6.44267 7.36471 6.44267 7.64965 6.30101 7.82543C6.15934 8.0012 5.92971 8.0012 5.78804 7.82543L4.57891 6.32511C4.51086 6.24073 4.47266 6.12622 4.47266 6.00686V3.60635C4.47266 3.35777 4.63507 3.15625 4.8354 3.15625Z",
    fill: "#1C1C1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetreatClockIcon);
export default __webpack_public_path__ + "static/media/retreat-clock-icon.36fc4b94925b7cf8457af299062e7ac7.svg";
export { ForwardRef as ReactComponent };